/** Prefixes public assets when the application is served from a subpath. */
export function publicPath(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;

  // Keep asset and API requests on the current origin so they also work through
  // preview URLs and reverse proxies.
  const configuredBasePath =
    process.env.NEXT_PUBLIC_BASE_PATH?.trim() || "/urban-studio";
  const basePath = `/${configuredBasePath}`
    .replace(/\/+/g, "/")
    .replace(/\/+$/, "");

  return `${basePath}${path.startsWith("/") ? path : `/${path}`}`;
}

/** Builds a URL for a Next.js API route from the configured base path. */
export const apiPath = (path: string) => publicPath(path);

/** Builds an absolute URL using the origin that is currently serving the app. */
export function absolutePublicPath(path: string): string {
  const relativePath = publicPath(path);

  if (typeof window === "undefined") return relativePath;

  return new URL(relativePath, window.location.origin).toString();
}
